<template>
  <div class="collectionlist">
    <div class="collectionlist__filter">
      <div class="collectionlist__filter__left">
        <div class="createnew">
          <button class="btn-regular primary loading" @click.stop="createCollection" :disabled="disabledCreateNew">
            Create new
            <adx-loading-secondary v-if="createnewIsLoading" slot="loading" />
          </button>
        </div>
        <adx-dropdown-list class="" @selected="selectedVisibility" :list="list" labelButton="All visibility" />
        <adx-dropdown-list class="mobile" @selected="selectedGroup" :list="quickfilter" labelButton="Filter" />
      </div>
      <div class="collectionlist__filter__right">
        <div class="search">
          <i class="adx-ic_search"></i>
          <input class="subhead" type="text" v-model="searchValue" placeholder="Search">
        </div>
      </div>
    </div>
    <div class="collectionlist__content">
      <div class="collectionlist__content__listview">
        <adx-collection-list-view :items="items" :isLoading="loadingPage" :menuList="expansionList" @statusChanged="updateVisibility" @dataChanged="updateData">
          <!-- <infinite-loading slot="infiniteLoading" @infinite="infiniteLoad($event)" :isFirstLoad="false" :distance="1" ref="InfiniteLoadingRefs">
            <span slot="no-more">
            </span>
            <span slot="no-results">
            </span>
            <span slot="spinner">
            </span>
          </infinite-loading> -->
          <template slot="loading" v-if="!loadingPage">
            <template v-if="!isLoading">
              <div v-if="next" class="collectionlist__content__listview__paging" @click.stop="infiniteLoad">
                <span class="collectionlist__content__listview__paging__load">Show more</span>
              </div>
              <div v-else class="collectionlist__content__listview__paging">
                <span class="collectionlist__content__listview__paging__empty"> There is no more data </span>
              </div>
            </template>
            <template v-else>
              <adx-loading />
            </template>
          </template>
        </adx-collection-list-view>
      </div>
      <div class="collectionlist__content__quickfilter">
        <adx-quickfilter :value.sync="selectedGroupValue" :list="quickfilter" />
      </div>
    </div>
  </div>
</template>

<script>
import DropdownList from '@/components/Dropdown/ListDropdown'
import CollectionListView from '@/views/Collection/CollectionList/ListItem'
import QuickFilter from '@/components/QuickFilter'
import InfiniteLoading from 'vue-infinite-loading'
import LoadingSpinner from '@/components/Loading/Secondary'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
const { helpers } = validationLib

export default {
  name: 'adx-collection-list',
  components: {
    'adx-dropdown-list': DropdownList,
    'adx-collection-list-view': CollectionListView,
    'adx-quickfilter': QuickFilter,
    'infinite-loading': InfiniteLoading,
    'adx-loading': Loading,
    'adx-loading-secondary': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      list: [
        {
          'id': 0,
          'label': 'All visibility',
          'value': '',
        },
        {
          'id': 1,
          'label': 'Public',
          'value': 'public'
        },
        {
          'id': 2,
          'label': 'Private',
          'value': 'private'
        },
      ],
      items: [],
      expansionList: [
        {
          "id": 0,
          "name": "Add to Group",
          "value": "group",
          "items": []
        },
        {
          "id": 1,
          "name": "Duplicate",
          "value": "duplicate"
        },
        {
          "id": 2,
          "name": "Delete Collection",
          "value": "delete"
        },
      ],
      quickfilter: [
        {
          'id': 0,
          'label': 'All',
          'value': '',
        }
      ],
      selectedGroupValue: '',
      selectedVisibilityValue: '',
      searchValue: '',
      loadingPage: false,
      isLoading: false,
      next: null,
      count: null,
      page: 1,
      disabledCreateNew: false,
      createnewIsLoading: false
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        visibility: this.selectedVisibilityValue || undefined,
        search: this.searchValue || undefined,
        group: this.selectedGroupValue || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
  },
  watch: {
    selectedGroupValue () {
      this.$nextTick(function () {
        this.loadData()
      })
    },
    searchValue: helpers.debounce(function() {
      this.$nextTick(function () {
        this.loadData()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
    this.loadFilter()
    this.loadExpansion()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    updateData() {
      this.$nextTick(function () {
        this.loadData()
      })
    },
    updateVisibility({ id, status }) {
      (async () => {
        const body = {
          id,
          visibility: status === 'Public' ? true : false
        }
        const { data } = await api.patch(apiV2.collectionDetail(id), body, { needToken: true })
        this.$notify({
          group: 'saved',
          title: 'Update Visibility Success',
          text: `${data.title} has been successfully changed to ${data.status}`,
          type: 'success'
        })
        this.$nextTick(function () {
          this.loadData()
        })
      })();
    },
    selectedVisibility(item){
      this.selectedVisibilityValue = item.value
      this.$nextTick(function () {
        this.loadData()
      })
    },
    selectedGroup(item){
      this.selectedGroupValue = item.value
      this.$nextTick(function () {
        this.loadData()
      })
    },
    infiniteLoad() {
      (async () => {
        if (this.$data.next) {
          this.$data.isLoading = true
          const params = {
            page: this.page,
            ...this.getFilterParams
          }
          const { data } = await api.get(apiV2.collectionList, { params, needToken: true })
          if (data.results) {
            this.$data.items = this.$data.items.concat(data.results)
            this.$data.count = data.count
            this.$data.next = data.next
            // $state.loaded();
            // if (!data.next) {
            //   $state.complete()
            // }
          } else {
            // $state.complete()
          }
          this.$data.page += 1
          this.$data.isLoading = false
        }
      })();
    },
    loadData() {
      (async () => {
        this.items = []
        this.loadingPage = true
        const params = {
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.collectionList, { params, needToken: true })
        this.items = data.results
        this.$data.count = data.count
        this.$data.next = data.next
        this.page = 2
        this.loadingPage = false
      })();
    },
    loadFilter() {
      (async () => {
        const { data } = await api.get(apiV2.collectionQuickFilter, { needToken: true })
        if (data.length > 0) {
          this.quickfilter = this.quickfilter.concat(data)
        }
      })();
    },
    loadExpansion() {
      (async () => {
        const { data } = await api.get(apiV2.groupListMenu, { needToken: true })
        if (data.length > 0) {
          this.expansionList[0].items = this.expansionList[0].items.concat(data)
        } else {
          this.expansionList[0].items = [{
            id: 1,
            name: `Empty`,
            value: `empty`
          }]
        }
      })();
    },
    createCollection() {
      (async () => {
        this.disabledCreateNew = true
        this.createnewIsLoading = true
        const params = {}
        const { data } = await api.post(apiV2.collection, params, { needToken: true })
        this.createnewIsLoading = false
        this.disabledCreateNew = false
        this.$router.push({ name: 'collectioneditor', params: { id: data.id } })
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>